import { defineStore } from "pinia";
import Network from "~/utils/network";

const urls = {
  getUserData: (publicId) => `/bnpl/external/user/${publicId}`, // GET
};

export const useUserStore = defineStore("user", {
  state: () => ({
    customerEmail: "",
    customerFirstName: "",
    customerLastName: "",
    customerPhone: "",
    publicId: "",
  }),
  actions: {
    load(user) {
      this.customerEmail = user.customerEmail;
      this.customerFirstName = user.customerFirstName;
      this.customerLastName = user.customerLastName;
      this.customerPhone = user.customerPhone;
    },
    fetchUserData: async function () {
      try {
        let data = await Network.http(urls.getUserData(this.publicId), {
          method: "GET",
        });
        this.load(data);
      } catch (err) {
        console.log(err);
        await Promise.reject(err);
      }
    },
    fetchUserDataByPublicId: async function (publicId) {
      try {
        let data = await Network.http(urls.getUserData(publicId), {
          method: "GET",
        });
        this.load(data);
      } catch (err) {
        console.log(err);
        await Promise.reject(err);
      }
    },
  },
});
